// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3wsQI","empty":"ModalGraph_empty__KH6yE"};